import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  useTheme,
} from "@mui/material";
import { Form, Formik } from "formik";
import React from "react";
import PrimaryButton from "../../../General/Components/PrimaryButton/PrimaryButton";

function FormikContainer({
  children,
  action,
  hasReset,
  initilaValue,
  validationSchema,
  callbackData=()=>{},
  handleClose,
  spacing = 1,
  buttonActionPadding = "0.5rem",
  disableSubmit = false,
  disableActionForm = false,
  formId = "formikContainer",
  setFormCurrentState = () => {},
}) {
  const theme = useTheme().palette.mode;
  return (
    <Formik
      enableReinitialize
      initialValues={initilaValue}
      validationSchema={validationSchema}
      validate={(data) => {
        setFormCurrentState(data);
      }}
      onSubmit={(data) => {
        callbackData(data);
      }}
    >
      {({
        values,
        setFieldValue,
        errors,
        touched,
        dirty,
        isValid,
        resetForm,
        submitForm,
      }) => (
        <Form
          style={{
            borderRadius: "8px",
            background: theme === "dark" ? "#1E232D" : "#FFF",
            padding: " 0.5rem",
            width: "100%",
          }}
          id={formId}
        >
          <Grid
            container
            spacing={spacing}
            sx={{ display: "flex", alignItems: "center" }}
          >
            {typeof children === "function"
              ? children({
                  values,
                  setFieldValue,
                  errors,
                  touched,
                  dirty,
                  isValid,
                  resetForm,
                  submitForm,
                })
              : React.Children.map(children, (child) =>
                  React.cloneElement(child, {
                    values,
                    setFieldValue,
                    errors,
                    touched,
                    dirty,
                    isValid,
                    resetForm,
                  }),
                )}
            {}
            {!disableActionForm && (
              <Grid
                display={"flex"}
                width={"100%"}
                justifyContent={"flex-end"}
                alignItems={"center"}
                padding={buttonActionPadding}
              >
                {hasReset && (
                  <Button
                    onClick={() => action.resetForm()}
                    // disabled={(!validReset)}
                    disabled={false}
                    sx={{
                      background: false
                        ? "rgba(0,0,0,0.2)" // حالت disabled
                        : "rgba(30, 106, 253, 1)",

                      color: false ? "#999" : "#fff",

                      borderRadius: "8px",
                      padding: "0.5rem 1rem",
                      marginRight: "2px",
                      "&:hover": {
                        background: false
                          ? "rgba(0,0,0,0.2)" // در disabled هوور نداشته باشد
                          : "rgba(30, 106, 253, 0.8)",
                      },
                    }}
                  >
                    بازنشانی
                  </Button>
                )}
                <PrimaryButton
                  disabled={disableSubmit}
                  sx={{
                    borderRadius: "8px",
                    backgroundColor: "#1E6AFD",
                    padding: "0.5rem 3rem",
                  }}
                  type={"submit"}
                  label={"ذخیره"}
                />

                {handleClose && (
                  <PrimaryButton
                    onClick={() => handleClose()}
                    variant="outlined"
                    sx={{ borderRadius: "8px", padding: "0.5rem" }}
                    label={"لغو"}
                    color="error"
                  />
    
                )}

              </Grid>
            )}
          </Grid>
        </Form>
      )}
    </Formik>
  );
}

export default FormikContainer;

const SubmitStatus = ({ optionStatus, label, statusState, setStatusState }) => {
  const handleChange = (e) => {
    setStatusState(e.target.value);
  };
  return (
    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
      <InputLabel id="demo-select-small-label">{label}</InputLabel>
      <Select
        labelId="demo-select-small-label"
        id="demo-select-small"
        value={statusState}
        label={label}
        onChange={handleChange}
      >
        {optionStatus?.map((item) => {
          return (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
